import type { IChoiceGroupOption } from "@fluentui/react";
import { ChoiceGroup } from "@fluentui/react";
import React, { useEffect, useState, type FormEvent } from "react";
import type { NodeProps, Node } from "@xyflow/react";
import { Zone } from "../../../api";
import type { ExtraNodeData, InterfaceToRecord } from "./action-config-node";
import ActionConfigNode, { indicationsZoneOptions } from "./action-config-node";
import { useTranslation } from "react-i18next";
import type { IndicationsData } from "../../../api/models/IndicationsData";
import { useUpdateNodeData } from "@/lib/hooks/reactflow";

type IndicationsNode = Node<InterfaceToRecord<IndicationsData & ExtraNodeData>>;

export default function Indications(props: NodeProps<IndicationsNode>): JSX.Element {
    const { t } = useTranslation();
    const [selectedZone, setSelectedZone] = useState(props.data.zone ?? Zone.ONE);

    const updateNode = useUpdateNodeData<IndicationsNode>(props.id);

    // We have to set the data to prevent undefined values
    useEffect(() => {
        updateNode({ zone: selectedZone });
    }, [selectedZone, updateNode]);

    function onChange(
        _e?: FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption,
    ): void {
        if (!option) {
            return;
        }
        setSelectedZone(option.key as Zone);
    }

    return (
        <ActionConfigNode nodeKind={props.type} {...props.data}>
            <ChoiceGroup
                options={indicationsZoneOptions(t)}
                selectedKey={selectedZone}
                onChange={onChange}
            />
        </ActionConfigNode>
    );
}
